import { render, staticRenderFns } from "./CurrentResolution.vue?vue&type=template&id=119e919e&"
import script from "./CurrentResolution.vue?vue&type=script&lang=js&"
export * from "./CurrentResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports